import React from 'react';
import CategoryTab from './CategoryTab';
import { v4 as uuid } from "uuid";

function CategoryTabs({
    categories,
    activeCategory,
    setActiveCategory,
    editingCategoryIndex,
    setEditingCategoryIndex,
    editingCategoryName,
    setEditingCategoryName,
    todoLists,
    setTodoLists,
    setCategories,
    userId,
    inputCatRef
}) {
    return (
        <ul className="nav nav-tabs">
            {categories.map((category, idx) => (
                <CategoryTab
                    key={uuid()}
                    category={category}
                    idx={idx}
                    activeCategory={activeCategory}
                    setActiveCategory={setActiveCategory}
                    editingCategoryIndex={editingCategoryIndex}
                    setEditingCategoryIndex={setEditingCategoryIndex}
                    editingCategoryName={editingCategoryName}
                    setEditingCategoryName={setEditingCategoryName}
                    categories={categories}
                    setCategories={setCategories}
                    todoLists={todoLists}
                    setTodoLists={setTodoLists}
                    userId={userId}
                    inputCatRef={inputCatRef}
                />
            ))}
        </ul>
    );
}

export default CategoryTabs;
